import filterHelper from './filterHelpers';
// Because this is only used by lokijs dynamicViews (as opposed to a paged database get),
// most of this is dependent on the ActiveRecord context boundary which is passed in via
// the contextualInfo parameter on fromHNode() below.
export default {
    getFilter,
    fromHNode,
    getUriComponent,
    getMql,
    getJavaScriptFilter
};

function fromHNode(hNode, contextualInfo) {
    const { namespace, relation, propertyName } = hNode;
    const foreignKey = contextualInfo?.activeRecord?.record?._id;
    return getFilter(namespace, relation, foreignKey, propertyName);
}

function getFilter(namespace, relation, foreignKey, propertyName) {
    return {
        namespace,
        relation,
        foreignKey,
        ...(propertyName && { propertyName })
    };
}

function getMql(filters) {
    if (filters.foreignRelationActiveRecord == null) return;
    const filter = filters.foreignRelationActiveRecord;
    return { [getRelationshipPath(filter)]: { $eq: filter.foreignKey } };
}

function getUriComponent(filters) {
    const filter = filters['foreignRelationActiveRecord'];
    const foreignIdPath = `["${getRelationshipPath(filter)}"]`;
    return `searchProperties=${encodeURIComponent(foreignIdPath)}&searchTerm=${encodeURIComponent(
        filter.foreignKey
    )}&exact=true`;
}

function getJavaScriptFilter(filter) {
    const propertyName = getRelationshipPath(filter);
    const value = filter.foreignKey;
    return filterHelper.basicFilterToJavaScript({ propertyName, op: '$eq', value });
}

/**
 * Most records use namespace:relation references. propertyName supports another
 * relationship on the listed record, such as baseEnvironment._id.
 */
function getRelationshipPath({ namespace, relation, propertyName }) {
    const relationship = propertyName || `${namespace}:${relation}`;
    return relationship.endsWith('._id') ? relationship : `${relationship}._id`;
}
